import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  TextField,
  CssBaseline,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Grid,
} from "@material-ui/core";
import PaisContext from "context/pais/paisContext";
import ProvinciaContext from "context/provincia/provinciaContext";
import LocalidadContext from "context/localidad/localidadContext";
import ValidationsContext from "context/validations/validationsContext";

import { makeStyles } from "@material-ui/core/styles";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Role } from "types/roles";

const useStyles = makeStyles((theme) => ({
  step: {
    width: "10%",
    display: "flex",
    flexDirection: "row",
    padding: "0px 1em 0px 0px",
    marginLeft: "65%",
    fontSize: "30px",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    display: "flex",
    height: "100%",
    flexDirection: "row-reverse",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formInputs: {
    width: "73.333333%",
    height: "100%",
  },
  formTelefonos: {
    width: "33.33333333%",
    height: "100%",
    marginLeft: "1.2em",
    padding: "0em 1em 1em 1em",
  },
  telList: {
    height: "50%",
    maxHeight: "30vh",
    width: "100%",
    marginRight: "0px",
    marginLeft: "1em",
    paddingBottom: "1em",
    paddingRight: "0px",
    paddingTop: "0px",
  },
  telListPaper: {
    width: "100%",
    height: "100%",
    maxHeight: "100%",
    marginRight: "0px",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
}));

export default function Formulario({
  grabarCliente,
  errorCliente,
  handleNext,
  handleBack,
  cliente,
}) {
  const classes = useStyles();

  const paisContext = useContext(PaisContext);
  const { paises, obtenerPaises } = paisContext;

  const provinciaContext = useContext(ProvinciaContext);
  const { provincias, obtenerProvincias, obtenerProvincia } = provinciaContext;

  const localidadContext = useContext(LocalidadContext);
  const { localidades, obtenerLocalidades, obtenerLocalidad } =
    localidadContext;

  const validationsContext = useContext(ValidationsContext);
  const {
    validateForm,
    validateUsername,
    validateeMail,
    validateDirecciones,
    validateCuit,
    validatePassword,
    validateCodigoArea,
    validateNumeroTelefono,
    validateRepeatPassword,
  } = validationsContext;
  
  const [state, setState] = useState({
    localidad: cliente.localidad ? cliente.localidad : " ",
    localidadNombre: cliente.localidadNombre ? cliente.localidadNombre : " ",
    paisSelect: cliente.paisSelect ? cliente.paisSelect : "",
    paisNombre: cliente.paisNombre ? cliente.paisNombre : "",
    provinciaSelect: cliente.provinciaSelect ? cliente.provinciaSelect : "",
    provinciaNombre: cliente.provinciaNombre ? cliente.provinciaNombre : "",
    direccion: cliente.direccion ? cliente.direccion : " ",
  });
  ////pasos step
  function getSteps() {
    return [" ", " ", " ", " "];
  }
  const steps = getSteps();
  ///fin step
  const isFormIncomplete = () => {
    return (
      state.paisSelect.trim() === "" ||
      state.provinciaSelect.trim() === "" ||
      state.localidad.trim() === "" ||
      state.direccion.trim() === ""
    );
  };
  useEffect(() => {
    //grabarCliente({"email":"dosmail@gmail.com","cuit":"00008777777","razonSocial":"mmppmmmm","direccion":"mmmpppmm","localidad":"608b0993355dc4ae2527d43b","telefono":[{"codigoPais":"+54 9","numeroTelefono":"777777","codigoArea":"7777"},{"codigoPais":"+54 9","numeroTelefono":"9587436","codigoArea":"258"}],"password":"Test123","nombre":"pepeeeeemm","rol":Role.Admin})
    if (paises.length === 0) {
      obtenerPaises();
    }
    setErrors({
      cuit: "",
      razonSocial: "",
      nombre: "",
      paisSelect: "",
      provinciaSelect: "",
      localidad: "",
      direccion: "",
      email: "",
      password: "",
      password2: "",
    });
    // eslint-disable-next-line
  }, []);

  const onChangePais = (e) => {
    setState({
      ...state,
      paisSelect: e.target.value,
      paisNombre: paises.filter((p) => p.id === e.target.value)[0].nombre,
      localidad: "",
    });
    obtenerProvincias(e.target.value);
  };
  const onChangeProvincia = (e) => {
    setState({
      ...state,
      provinciaSelect: e.target.value,
      provinciaNombre:provincias.filter((p) => p.id === e.target.value)[0].nombre,
      localidad: "",
    });
    obtenerLocalidades(e.target.value);
  };
  const onChange = (e) => {
    // cargo el preview
    if (e.target.name === "direccion") {
      setState({
        ...state,
        [e.target.name]: e.target.value,
      });
    } else {
      setState({
        ...state,
        [e.target.name]: e.target.value,
        localidadNombre: localidades.filter((p) => p.id === e.target.value)[0].nombre,
      });
    }
    switch (e.target.name) {
      case "nombre":
        setErrors({
          ...errors,
          nombre: validateUsername(e.target.value),
        });
        break;
      case "razonSocial":
        setErrors({
          ...errors,
          razonSocial: validateUsername(e.target.value),
        });
        break;
      case "direccion":
        setErrors({
          ...errors,
          direccion: validateDirecciones(e.target.value),
        });
        break;
      case "email":
        setErrors({
          ...errors,
          email: validateeMail(e.target.value),
        });
        break;
      case "password":
        setErrors({
          ...errors,
          password: validatePassword(e.target.value),
          password2: validateRepeatPassword(state.password, e.target.value),
        });
        break;
      case "password2":
        setErrors({
          ...errors,
          password2: validateRepeatPassword(e.target.value, state.password),
        });
        break;
      case "cuit":
        setErrors({
          ...errors,
          cuit: validateCuit(e.target.value),
        });
        break;
      default:
        break;
    }
  };

  const [errors, setErrors] = useState({
    cuit: "",
    razonSocial: "",
    nombre: "",
    paisSelect: "",
    provinciaSelect: "",
    localidad: "",
    direccion: "",
    email: "",
    password: "",
    password2: "",
  });

  // Cuando el usuario guardar o actualizar la localidad
  const onSubmit = (e) => {
    e.preventDefault();
    // Validar que no haya campos vacios
    if (!validateForm(errors) || isFormIncomplete()) {
      errorCliente("Todos los campos con * son obligatorios", "error");
    } else {
      setErrors({
        cuit: "",
        razonSocial: "",
        nombre: "",
        paisSelect: "",
        provinciaSelect: "",
        localidad: "",
        direccion: "",
        email: "",
        password: "",
        password2: "",
      });
    }
  };
  return (
    <div style={{ width: "550px" }}>
      <Stepper
        nonLinear
        activeStep={1}
        className={classes.step}
        style={{ backgroundColor: "#fafafa" }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton style={{ cursor: "default" }}>{label}</StepButton>
          </Step>
        ))}
      </Stepper>
      <CssBaseline />
      <div
        className={classes.form}
        noValidate
        onSubmit={onSubmit}
        autoComplete="off"
      >
        <Grid
          container
          direction="row"
          /* justify="space-around"  */ spacing={1}
        >
          <Grid item xs={3}>
            <FormControl variant="outlined" fullWidth margin="normal">
              <InputLabel id="pais-label">Pais</InputLabel>
              <Select
                error={state.paisSelect.length === 0}
                labelId="demo-simple-select-outlined-label"
                id="pais"
                name="pais"
                value={state.paisSelect}
                onChange={onChangePais}
                label="Pais"
              >
                {paises.length === 0 ? (
                  <MenuItem value="">No hay paises</MenuItem>
                ) : (
                  paises.map((p) => (
                    <MenuItem key={p.id} value={p.id}>
                      {p.nombre}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl variant="outlined" fullWidth margin="normal">
              <InputLabel id="pais-label">Provincia</InputLabel>
              <Select
                error={state.provinciaSelect.length === 0}
                labelId="demo-simple-select-outlined-label"
                id="provincia"
                name="provincia"
                value={state.provinciaSelect}
                onChange={onChangeProvincia}
                label="Provincia"
              >
                {provincias.length === 0 ? (
                  <MenuItem value="">No hay provincia</MenuItem>
                ) : (
                  provincias.map((prov) => (
                    <MenuItem key={prov.id} value={prov.id}>
                      {prov.nombre}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={5}>
            <FormControl variant="outlined" fullWidth margin="normal">
              <InputLabel id="pais-label">Localidad</InputLabel>
              <Select
                error={state.localidad.length === 0}
                labelId="demo-simple-select-outlined-label"
                id="localidad"
                name="localidad"
                value={state.localidad}
                onChange={onChange}
                label="Localidad"
              >
                {localidades.length === 0 ? (
                  <MenuItem value="">No hay localidades</MenuItem>
                ) : (
                  localidades.map((loc) => (
                    <MenuItem key={loc.id} value={loc.id}>
                      {loc.nombre}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              error={errors.direccion.length > 0}
              fullWidth
              variant="outlined"
              margin="normal"
              id="direccion"
              label={
                errors.direccion.length > 0 ? errors.direccion : "Dirección"
              }
              name="direccion"
              value={state.direccion}
              onChange={onChange}
            />
          </Grid>
          <Grid item xs={6}>
            <Grid item xs={10} md={10} lg={10}>
              <Button
                mx="auto"
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => handleBack()}
                style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
              >
                Volver
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container justify="flex-end">
              <Grid item xs={10} md={10} lg={10}>
                { /* isFormIncomplete() || */  !validateForm(errors) ? (
                  <Button
                    mx="auto"
                    type="submit"
                    disabled
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Siguiente
                  </Button>
                ) : (
                  <Button
                    mx="auto"
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => handleNext(state)}
                    style={{ color: "#FCFCFC", backgroundColor: "#0B3845" }}
                  >
                    Siguiente
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
